<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="rmn"
      title="NMR"
      logo="img/logo.png"
    >
      <template v-slot:links>
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-tv-2 text-primary',
            path: '/',
          }"
        />
        <sidebar-item
          v-if="getUser.isAdmin"
          :link="{
            name: 'Instruments',
            icon: 'fa fa-magnet text-blue',
            path: '/instruments',
          }"
        />
        <sidebar-item
          v-if="getUser.isAdmin"
          :link="{
            name: 'Users',
            icon: 'fa fa-users text-blue',
            path: '/users',
          }"
        />
        <sidebar-item
          v-if="getUser.isAdmin"
          :link="{
            name: 'Groups',
            icon: 'ni ni-folder-17 text-blue',
            path: '/groups',
          }"
        />
        <sidebar-item
          v-if="getUser.isAdmin"
          :link="{
            name: 'Solvents',
            icon: 'ni ni-palette text-blue',
            path: '/solvents',
          }"
        />
        <sidebar-item
          v-if="getUser.isAdmin"
          :link="{
            name: 'Experiments',
            icon: 'fa fa-flask text-blue',
            path: '/experiences',
          }"
        />
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <!-- your content here -->
        <router-view></router-view>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { mapGetters } from 'vuex'

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
    };
  },
  computed: {
      ...mapGetters(['getUser'])
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
<style lang="scss">
.navbar-vertical .navbar-brand-img, .navbar-vertical .navbar-brand > img {
  max-height: 5.5rem !important;
} 
</style>
